import { Routes, Route } from 'react-router-dom'
import { ThemeProvider } from '../contexts/ThemeContext'
import { AuthProvider } from '../contexts/AuthContext'
import Footer from '../components/Footer'
import GoToTop from '../components/GoToTop'
import RenewalWarningCard from '../components/RenewalWarningCard'
import 'primeicons/primeicons.css'

// Pages
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ProfilePage from './pages/ProfilePage'
import CheckInPage from './pages/CheckInPage'
import LeaderboardPage from './pages/LeaderboardPage'
import ChallengesPage from './pages/ChallengesPage'
import ChallengeDetailPage from './pages/ChallengeDetailPage'
import ClassesPage from './pages/ClassesPage'
import ContactPage from './pages/ContactPage'
import CurriculumPage from './pages/CurriculumPage'
import OnlineCoursePage from './pages/OnlineCoursePage'
import CourseDetailPage from './pages/CourseDetailPage'
import LessonDetailPage from './pages/LessonDetailPage'
import PaymentPage from './pages/PaymentPage'
import MyCoursesPage from './pages/MyCoursesPage'
import TrainingGroupsPage from './pages/TrainingGroupsPage'
import TrainingGroupDetailPage from './pages/TrainingGroupDetailPage'
import TrainingGroupGroupPage from './pages/TrainingGroupGroupPage'
import ReportsAppealsPage from './pages/ReportsAppealsPage'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/checkin" element={<CheckInPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/challenges" element={<ChallengesPage />} />
          <Route path="/challenges/:id" element={<ChallengeDetailPage />} />
          <Route path="/classes" element={<ClassesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/curriculum" element={<CurriculumPage />} />
          <Route path="/course/online" element={<OnlineCoursePage />} />
          <Route path="/course/online/:id" element={<CourseDetailPage />} />
          <Route path="/course/online/:courseId/lesson/:lessonId" element={<LessonDetailPage />} />
          <Route path="/course/online/payment" element={<PaymentPage />} />
          <Route path="/course/my-courses" element={<MyCoursesPage />} />
          <Route path="/training_groups" element={<TrainingGroupsPage />} />
          <Route path="/training_groups/:id" element={<TrainingGroupDetailPage />} />
          <Route path="/training_groups/group/:id" element={<TrainingGroupGroupPage />} />
          <Route path="/reports-appeals" element={<ReportsAppealsPage />} />
        </Routes>
        <Footer />
        <GoToTop />
        <RenewalWarningCard />
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App

